export default "__VITE_ASSET__8b4b79e5__"